(function ($, Drupal) {

  // title, text and so height matching inside cards
  Drupal.behaviors.initHeightMatch = {
    attach: function (context, settings) {

      $('.cardgrid .layout, .shop__list', context).once('initHeightMatch').each(function () {

        const $layout = $(this),
              $resPixel = $('.js_resolution');
        // Add specific .card--X / Ecommerce--B elements on which to perform height matching.
        if ($layout.find('.card--A').length || $layout.find('.card--L').length || $layout.find('.ecommerce--B')) {

          const $elements = [
            $layout.find('.card__heading'),
            $layout.find('.card__lead'),
            $layout.find('.card__text'),
            $layout.find('.card__price'),
            $layout.find('.card__attributes'),
            $layout.find('.ecommerce__text'),
            $layout.find('.card__bundle-title')
          ];

          function setHeight($el) {
            let setHeight = 0;
            $el.each(function () {
              const $el = $(this).css('height', '');
              let elHeight = $el.height();
              if (elHeight > setHeight) {
                setHeight = elHeight;
              }
            });
            $el.height(setHeight);
          }

          function initElements() {
            for (let $el of $elements) {
              setHeight($el);
            }
          }

          const trigger = throttle((e) => {
            if ($resPixel.css('opacity') != '0') {
              initElements();
            }
          }, 500);

          trigger();
          $(window).resize(trigger);
        }
      });

      // product page
      $('.page-node-296 .commerce__product .card__heading').matchHeight();
      $('.page-node-296 .commerce__product .card__text').matchHeight();
      $('.page-node-296 .card--N .card__text').matchHeight();

      // product pages discover more block
      $('.cardgrid[data-class="discovermorecardgrid"] .card--A .card__heading, .cardgrid[data-class="discovermore"] .card--A .card__heading, ' +
        '.cardgrid[data-class="discovermorecg"] .card--A .card__heading').matchHeight();
      $('.cardgrid[data-class="discovermorecardgrid"] .card--A .card__text, .cardgrid[data-class="discovermore"] .card--A .card__text, ' +
        '.cardgrid[data-class="discovermorecg"] .card--A .card__text').matchHeight();
      $('.cardgrid[data-class="discovermorecardgrid"] .card--A .card__data .card__image-title-mobile .card__bundle-title, ' +
        '.cardgrid[data-class="discovermore"] .card--A .card__data .card__image-title-mobile .card__bundle-title, ' +
        '.cardgrid[data-class="discovermorecg"] .card--A .card__data .card__image-title-mobile .card__bundle-title').matchHeight();
      $('.cardgrid[data-class="discovermorecardgrid"] .card--A .card__data .card__image-title .card__bundle-title, ' +
        '.cardgrid[data-class="discovermore"] .card--A .card__data .card__image-title .card__bundle-title, ' +
        '.cardgrid[data-class="discovermorecg"] .card--A .card__data .card__image-title .card__bundle-title').matchHeight();
      $('.cardgrid[data-class="discovermorecardgrid"] .card--A .card__data .ecommerce__price, .cardgrid[data-class="discovermore"] .card--A .card__data .ecommerce__price, ' +
        '.cardgrid[data-class="discovermorecg"] .card--A .card__data .ecommerce__price').matchHeight();
      $('.review__item .comment__content').matchHeight();

    }
  };

})(jQuery, Drupal);
